
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserForConfigPartial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secretKey"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"io"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"budgetType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessNativeADType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessPlayableADType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifyRoasCampaigns"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isROASEnabledAndroid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isROASEnabledIOS"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifyCPPUCampaigns"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCPPUEnabledAndroid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCPPUEnabledIOS"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifyCPECampaigns"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCPEEnabledAndroid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCPEEnabledIOS"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"accountBlackList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appBlackList"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignBudget"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daily"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"rateTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"definition"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":724}};
    doc.loc.source = {"body":"#import \"./fragments.graphql\"\n\nfragment UserForConfigPartial on UserConfig {\n  user {\n    id\n    name\n    email\n    secretKey\n  }\n  account {\n    id\n    name\n    io {\n      signed\n    }\n    budgetType\n    permissions {\n      accessNativeADType\n      accessPlayableADType\n      modifyRoasCampaigns\n      isROASEnabledAndroid\n      isROASEnabledIOS\n      modifyCPPUCampaigns\n      isCPPUEnabledAndroid\n      isCPPUEnabledIOS\n      modifyCPECampaigns\n      isCPEEnabledAndroid\n      isCPEEnabledIOS\n    }\n    accountBlackList\n    appBlackList\n  }\n  campaignBudget {\n    daily {\n      max\n      min\n    }\n    total {\n      max\n      min\n    }\n    rateTypes {\n      id\n      name\n      min\n      max\n      definition\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./fragments.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UserForConfigPartial"] = oneQuery(doc, "UserForConfigPartial");
        
